export function orderEvents(a, b) {
    if (!a.version && !b.version) {
        return a.timestamp.localeCompare(b.timestamp);
    }
    if (!a.version) {
        return 1;
    }
    if (!b.version) {
        return -1;
    }
    return a.version - b.version;
}
//# sourceMappingURL=orderEvents.js.map